import { Component, computed, inject, signal } from '@angular/core';
import { AuthService, DataService } from '@shared/services';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { Router, RouterLink } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CommonModule } from '@angular/common'; // <-- Import CommonModule

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
  imports: [
    CommonModule, 
    PopoverModule,
    RouterLink,
    TooltipModule
  ]
})
export class HeaderComponent {
  private readonly router = inject(Router);
  private readonly dataService = inject(DataService);
  public readonly authService = inject(AuthService);

  readonly isOpenEditorSwitcher = signal<boolean>(false);

  // Returns the custom avatar URL or null if not set
  readonly userCustomAvatarUrl = computed(() => {
    const user = this.authService.user();
    // Assuming dataService.loadAvatar(user) returns a URL string or null/undefined
    return user ? this.dataService.loadAvatar(user) : null;
  });

  // Generates user initials
  readonly userInitials = computed(() => {
    const user = this.authService.user();
    if (!user) {
      return '?'; // Fallback if no user
    }

    const name = user.name;
    const username = user.username;
    let initials = '';

    if (name && name.trim()) {
      const nameParts = name.trim().split(' ').filter(part => part.length > 0);
      if (nameParts.length >= 2) {
        // Use first letter of the first and last part of the name
        initials = (nameParts[0][0] + (nameParts[nameParts.length - 1][0] || '')).toUpperCase();
      } else if (nameParts.length === 1 && nameParts[0].length > 0) {
        // Use the first letter of the single name part
        initials = nameParts[0][0].toUpperCase();
      }
    }

    if (!initials && username && username.trim()) {
      // Fallback to the first letter of the username if name didn't yield initials
      initials = username.trim()[0].toUpperCase();
    }

    return initials || '?'; // Final fallback
  });

  logout() {
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }

  showFeedbackWarning(): void {
    const confirmed = confirm(
      'Du verlässt unsere Website und wirst zu Google Forms weitergeleitet.\n\n' +
      'Hinweis: Dort gelten die Datenschutzbestimmungen von Google.\n\n' +
      'Möchtest du fortfahren?'
    );

    if (confirmed) {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSf6L_BeLU9fpy2vf3AKvLzPF9bbMfNJrZ_TVANjfDfdJj9RwA/viewform', '_blank', 'noopener,noreferrer');
    }
  }
}
